import AgGridWrapper from "../../su/AgGridWrapper.js";
import PageDetail from "../abstract/PageDetail.js";
import { SecurityAcl, AuthCheckAcl } from "../../Security.js";
import { ModalAlert, ModalConfirm } from "../../su/Modals.js";

export default class PageDMSDetail extends PageDetail {
    constructor() {
        super();
    }

    init($data) {
        this.SelectedObjects = [];
        this.SelectedObjectsCounter = 0;
        super.init($data);
        this.onGotoSection();
        $(".jsBtnDeleteSelected").on("click", this.deleteRow.bind(this, undefined));
        $(".jsBtnExportSelected").on("click", this.exportSelected.bind(this, undefined));
        $(".js-detail-tab-btn").addClass("active");
        $(".js-questionario-tab-btn").removeClass("active");

        this.grid = this.initAgList();

    }

    onGotoSection() {
        let args = StateManager._splitUrl(document.location.href);
        let url = Base64.toBase64(this.data.row.Uid) + "?_vs=" + encodeURIComponent(args.qPart["_vs"]) + "&_pi=" + encodeURIComponent(args.qPart["_pi"]);
        if (this.data.prevPageId != undefined)
            url = Base64.toBase64(this.data.row.Uid, true) + "?_vs=" + encodeURIComponent(args.qPart["_vs"]) + "&_pi=" + encodeURIComponent(data.PrevPageId);

        $(".js-detail").on('click', this.onGotoDetail.bind(this, url));
    }

    onGotoDetail(url) {
        $(".js-detail").attr("href", "/dms/detail/" + url);
    }



    getAvailableHeight() {
        let a = jQuery(".js-size");
        let i = 0;
        for (let x = 0; x < a.length; x++) {
            i += jQuery(a[x]).outerHeight();
        }
        i += 50; // padding app container
        i += 78; // search box
        i += 143; // paging
        let h = jQuery(window).height() - i;
        return h;
    }

    initAgList() {
        const rowData = [];
        for (let x = 0; x < this.data.rows.Items.length; x++) {
            const row = this.data.rows.Items[x];
            rowData.push(row);
        }
        this.rowData = rowData;

        const searchBox = document.getElementById("filter-text-box");

        const targetGrid = document.querySelector(".js-aglist");
        const h = this.getAvailableHeight();
        targetGrid.style.height = h + "px";
        targetGrid.style.overflowX = "auto"; // Enable horizontal scrolling

        const columnDefs = [
            {
                field: "Year",
                headerName: "Anno",
                rowGroup: true,
                hide: true,
                type: AgGridWrapper.TYPE_MULTILINE,

            },
            {
                field: "Month",
                headerName: "Mese",
                rowGroup: true,
                hide: true,
                minWidth:150,
                
                cellRenderer: (params) => {
                    var months = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
                    return months[params.value-1];
                },

                getQuickFilterText: params => {
                    var months = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
                    return months[params.value - 1];
                }
            },
            {
                field: "FileName",
                headerName: "Nome file",
                getQuickFilterText: () => '',
                minWidth:150,
            },
            {
                field: "SignatoryName",
                headerName: "Nome firmatario",
                minWidth:150,
            },
            {
                field: "SignatoryFiscalNumber",
                headerName: "Codice fiscale firmatario",
                minWidth:150,
            },
            {
                field: "CheckOCR",
                headerName: "Check OCR",
                minWidth:40,
                cellRenderer: (params) => {
                    if (params.node && params.node.group) {
                        return '';
                    }
                    return params.value == true ? "Si" : "No";
                },
            },
            {
                field: "RecordDtInsert",
                headerName: "Data Creazione",
                type: AgGridWrapper.TYPE_DATE_LOCAL_STRING_SHORTER,
                minWidth: 150,
            },
            {
                field: "RecordDtUpdate",
                headerName: "Data Aggiornamento",
                type: AgGridWrapper.TYPE_DATE_LOCAL_STRING_SHORTER,
                minWidth: 150,
            },
            {
                field: "Action",
                sortable: false,
                type: AgGridWrapper.TYPE_CTA,
                minWidth:140,
                checkboxSelection:true,
                actions: this.createActions(this)
            }
        ];

        // Inizializzazione della griglia (Copia incolla tranne il primo parametro che è un id arbitrario ma usiamo generalmente il nome della pagina)
        let agGrid = new AgGridWrapper("PageDMSDetailList", AgGridWrapper.MODE_SIMPLE);
        const options = agGrid.getConfig({

            paginationPageSize: 20,
            paginationPageSize: 20,
            rowSelection: "multiple",
            groupSelectsChildren: true,
            suppressRowClickSelection: true,
            suppressAggFuncInHeader: true,
            suppressHorizontalScroll:false,
            alwaysShowHorizontalScroll:true,

            customOptions: {
                doNotshowSelection: false, // In modo casereccio non mostra la selezione
                removeOldList: false, // Rimuove la vecchia griglia dalla pagina (punta sul fatto che i nodi che la contengono si chiamino "jsList" e "filterbox" grazie al solito copia-incolla selvaggio).
            },

            onGridReady: (params) => {
                  var defaultSortModel = [
                    { colId: "Year", sort: "desc", sortIndex: 0 },
                    { colId: "Month", sort: "desc", sortIndex: 0 },
                ];

                params.api.applyColumnState({ state: defaultSortModel });

                params.api.forEachNode(function (node) {
                    // chiedere a bog se non si capisce... e un casino
                    if (node.rowIndex === 0) {
                        node.setExpanded(true);
                    }
                    if (node.childIndex === 0 && node.parent.rowIndex === 0) {
                        node.setExpanded(true);
                    }
                    
                });

            },
            onSelectionChanged: (params) => {
                this.onSelectionChanged(this, params);
            },
            // dare un nome alla row group
            autoGroupColumnDef: {
                headerName: 'Anno'
            },
            columnDefs,
            rowData,
        });

        // Crea la griglia e ascolta il resize della finestra per cambiare l'altezza
        agGrid.init(targetGrid, searchBox, options);
        window.onresize = this.arrangeGrid.bind(this, agGrid);
        return agGrid.agGrid;  
    }

    
    onSelectionChanged(page,params) {
        let rows = params.api.getSelectedRows();
        this.SelectedObjectsCounter = rows.length;
        this.SelectedObjects = rows;

        $(".js-selected-counter").text(this.SelectedObjectsCounter);


        if (this.SelectedObjectsCounter === 0 && !$(".jsBtnDeleteSelected", ".js-btn-selected-wrap", '.jsBtnExportSelected').hasClass("is-disabled")) {
            $(".jsBtnDeleteSelected", ".js-btn-selected-wrap", ".jsBtnExportSelected").addClass("is-disabled");
        }

        if (this.SelectedObjectsCounter === 0 && !$(".jsBtnExportSelected", ".js-btn-selected-wrap").hasClass("is-disabled")) {
            $(".jsBtnExportSelected", ".js-btn-selected-wrap").addClass("is-disabled");
        }

        if (this.SelectedObjects.length == 0) {
            $(".jsBtnDeleteSelected", ".js-btn-selected-wrap").addClass("is-disabled");
            $(".jsBtnExportSelected", ".js-btn-selected-wrap").addClass("is-disabled");
            $('.jsBtnDeleteSelected').removeClass('active');
            $('.jsBtnExportSelected').removeClass('active');
        }
        else {
            $(".jsBtnDeleteSelected", ".js-btn-selected-wrap").removeClass("is-disabled");
            $('.jsBtnDeleteSelected').addClass('active');
            $(".jsBtnExportSelected", ".js-btn-selected-wrap").removeClass("is-disabled");
            $('.jsBtnExportSelected').addClass('active');
        }
    }

    arrangeGrid(agGrid) {
        // Punta alla griglia e ne imposta l'altezza
        const h = this.getAvailableHeight();
        agGrid.targetGrid.style.height = h + "px";
}

    createActions(p) {
        let actions = [
            {
                hasPermission: this.hasPerm.bind(this),
                type: AgGridWrapper.CTA_DELETE,
                callback: this.deleteRow.bind(p),
            },
            {
                hasPermission: this.hasPerm.bind(this),
                type: AgGridWrapper.CTA_CREATE,
                callback: this.createRow.bind(p),
            },

        ];

        return actions;

    }
    hasPerm(params, action) {
        if (params.node.field === "Month") {
            if (AgGridWrapper.CTA_CREATE == action) {
                return this.aclContext.HasGrantedAcl(new AuthCheckAcl("|DMS|*", SecurityAcl.ACL_CREATE));
            }
        }
        if (AgGridWrapper.CTA_DELETE == action) {
            if (params.node.data?.OriginCms == "True") return true;
            return this.aclContext.HasGrantedAcl(new AuthCheckAcl("|DMS|*", SecurityAcl.ACL_DELETE) || params.node.data?.OriginCms);
        }
    }
    createRow(params) {
        var month = params.node.key;
        var year = (params.node.parent.key);
        //StateManager.setViewState("Month", month);
        //StateManager.setViewState("Year", year);

        let args = StateManager._splitUrl(document.location.href);
        let url = Base64.toBase64(this.data.row.Uid) +"/" +year + "/" +month + "?_vs=" + encodeURIComponent(args.qPart["_vs"]) + "&_pi=" + encodeURIComponent(args.qPart["_pi"]);
        document.location.href = TheApp.Env.BaseUrlNls + "dms/upload/" + url;
    }

    deleteRow(params) {
        let modal = new ModalConfirm($("#template-modalConfirm"));
        const Items = [];

        if (!params) {
            for (let item of this.SelectedObjects) {
                Items.push(item);
            }
        }
        else {
            if (params.node.group) {
                Object.keys(params.node.allLeafChildren).forEach(function (key) {
                    Items.push(params.node.allLeafChildren[key].data);
                });
            }
            else {
                Items.push(params.node.data);
            }
        }

        modal.create(
            {
                title: "CONFERMA CANCELLAZIONE",
                body: "Sei sicuro di voler rimuovere definitivamente questi elementi? Non puoi annullare questa azione.",
                yes: "SI",
                no: "NO",
                danger: true // viene il pulsante rosso, altrimenti blue
            }, this.onConfirmDelete.bind(this, Items));
        modal.init();
        return;
    }

    onConfirmDelete(items, bConfirm) {
        if (bConfirm) {
            this.showPreloader(true);
            let uids = [];
            for (let i = 0; i < items.length; i++) {
                uids.push(items[i].Uid);
            }
            let rq = {
                Uids: uids,
            }
            thatServiceManeger.standardCall(this.data.serviceDeleteRoute, rq, this.onDeleteServiceHandler.bind(this, items));
            return;
            }
    }

    onDeleteServiceHandler(items, rs) {
        this.showPreloader(false);

        //
        if (rs.Success) {
            //this.theGrid.deleteByDataIndex(dataIndex);
            let modal = new ModalAlert($("#template-modalAlert"));
            modal.create(
                {
                    title: "SUCCESSO",
                    body: "CANCELLAZIONE TERMINATA CORETTAMENTE!",
                    close: "CHIUDI",
                    error: false
                });
            modal.init();
            /// rimuove il record dalla tabella
            this.grid.applyTransaction({ remove: items });
        } else {
            let error = null;
            if (rs.hasOwnProperty('Errors') && rs.Errors !== null && rs.Errors.length >= 0) {
                error = TheApp.Res[TheApp.Locale]["ERROR." + rs.Errors[0].Code];
                if (rs.Errors[0].RefsUid.length > 0) {
                    error = error.replace("{0}", rs.Errors[0].RefsUid);
                }
            }
            if (!error)
                error = TheApp.Res[TheApp.Locale]["ERROR.HTTP." + rs.StatusCode];
            if (!error)
                error = TheApp.Res[TheApp.Locale]["ERROR.HTTP.DEFAULT"];
            let modal = new ModalAlert($("#template-modalAlert"));
            modal.create(
                {
                    title: "Si è verificato un'errore",
                    body: error,
                    close: "CHIUDI",
                    error: true
                });
            modal.init();
        }
        //this.showPreloader(false);
    }




    async exportSelected(params) {
        const Items = [];
        var fileExt = "zip";
        if (this.SelectedObjects.length == 1) {
            fileExt = (this.SelectedObjects[0].FileName.split('.')).pop();
        }
        if (!params) {
            for (let item of this.SelectedObjects) {
                Items.push(item.Uid);
            }
        }


        let rq = {
            Uids: Items,
            VATNumber: this.data.row.VATNumber,
            CustomerTradingName: this.data.row.CustomerTradingName
        }

        await fetch(this.data.serviceExportRoute, {
            body: JSON.stringify(rq),
            headers: {
                "Content-Type": "application/json",
                api_key: TheApp.CurrentContext.app.jsApiKey,
                access_token: TheApp.CurrentContext.userSession.Bearer,
            },
            method: "POST",
            credentials: 'include',
        }).then((response) => {
            if (response.ok) {
                return response.blob();
            }
            else {
                throw new Error('Qualcosa è andato storto.');
            }
        }).then((bytes) => {
            let elm = document.createElement('a');
            elm.href = URL.createObjectURL(bytes);
            elm.setAttribute('download', `${rq.VATNumber}-documents.${fileExt}`);
            elm.click()
        }).catch((error) => {
            let modal = new ModalAlert($("#template-modalAlert"));
            modal.create(
                {
                    title: "Si è verificato un'errore",
                    body: error,
                    close: "CHIUDI",
                    error: true
                });
            modal.init();
        })

    }



}

